import React from 'react';
import StepsLogin from './StepsLogin';
import ViewsLogin from './ViewsLogin';
import { useSelector } from 'react-redux';
import Loading from '../../../components/loading/Loading';
// import Header from '../../layout/Header';
import Navbar from '../../layouts/layoutMain/Navbar';

// import ViewCreateVendor from '../vendors/ViewCreateVendor';
// import InitCreateVendor from '../vendors/InitCreateVendor';

const LoginLayout = () => {
    const { loginView, loading } = useSelector(state => state.auth);

    return (
        <>
            {loading && <Loading />}
            {/* <Header /> */}
            <Navbar />
            <div className="loginLayout__container">
                {loginView <= 3 && <StepsLogin view={loginView} />}
                {/* {loading && <Loading />} */}
                <ViewsLogin view={loginView} />
            </div>
            {/* test steps */}
            {/* <ViewCreateVendor /> */}
            {/* <InitCreateVendor /> */}
        </>
    );
};

export default LoginLayout;
